// Fonts
import 'zignal-landscape/lib/styles/fonts/roboto.css';

import BaseTheme from 'zignal-landscape/lib/Light';

// Theme CSS
import 'zignal-landscape/lib/Light.css';

// Components
import LoginForm from 'containers/Login/components/LoginForm/themes/LoginFormLight.css';

export default Object.assign({}, BaseTheme, {
  LoginForm
});
